import React from 'react';
import I18n from 'i18n-js';

import CsrfForm from '../csrf_form';
import { APPLE_AUTH_PATH } from '../url_helpers';
import AppleIcon from '../../design-system/icons/core/apple.svg?component';
import { RCTextWithIcon } from '../rc/RCTextWithIcon';

interface Props {
  redirectTo?: string;
  isSignup?: boolean;
}

export default function AppleSignInButton(props: Props) {
  const id = 'apple-signup-signin';

  const title = props.isSignup
    ? I18n.t('commons.signupForm.appleSignUp')
    : I18n.t('commons.signupForm.appleSignIn');

  return (
    <CsrfForm
      id={id}
      method="post"
      action={APPLE_AUTH_PATH.expand({ redirect_to: props.redirectTo })}
    >
      <input type="hidden" name="name" value="value" />
      <button
        type="submit"
        form={id}
        className="button button--primary width-100"
      >
        <RCTextWithIcon svgComponent={AppleIcon} placement="left">
          {title}
        </RCTextWithIcon>
      </button>
    </CsrfForm>
  );
}
